import Vue from 'vue'
import App from './App.vue'

import store from './store'

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueShortkey from 'vue-shortkey'
Vue.use(VueShortkey)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import Ripple from 'vue-ripple-directive';
Vue.directive('ripple',Ripple);

import testWpData from './components/testWpData.js'

const app = new Vue({
  el: '#wp-vue-app',
  store,
  created() {
    let wpData = window.wpData? window.wpData : testWpData
    // Vue app demo only
    // let wpData = { rest_url : 'http://clients.madebycaliper.com/satsuma/wp-json' }
    this.$store.commit('setWpData', wpData);

    // If the user is logged out, revoke the jwt
    if( !wpData.user.logged_in ) {
      delete localStorage.authToken
      localStorage.removeItem('authToken');
    }

    let authToken = false;
    if( localStorage.authToken ) {
      authToken = localStorage.authToken;
    } else if ( wpData.authToken ) {
      authToken = wpData.authToken;
      localStorage.setItem('authToken', authToken);
    }

    if( authToken ) {
      this.$store.commit('setAuthToken', authToken );
    }
  },
  render: h => h(App)
})

global.app = app


// WEBPACK FOOTER //
// ./src/main.js